import { render, staticRenderFns } from "./TechnicalServiceBulletins.vue?vue&type=template&id=2fcb763a&scoped=true"
import script from "./TechnicalServiceBulletins.vue?vue&type=script&lang=js"
export * from "./TechnicalServiceBulletins.vue?vue&type=script&lang=js"
import style0 from "./TechnicalServiceBulletins.vue?vue&type=style&index=0&id=2fcb763a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fcb763a",
  null
  
)

export default component.exports